export enum AttributeType {
  LDAP = 'ldap',
}
